<template>
  <div>
    <div class="gdlr-core-pbf-wrapper" style="padding: 370px 0px 160px 0px;" data-skin="white" id="gdlr-core-wrapper-1">
      <div class="gdlr-core-pbf-background-wrap" style="background-color: #212121;">
        <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
             style="opacity: 0.4; background-image: url(static/upload/slider-2-bg.jpg); background-size: cover; background-position: center center; height: 795.25px; transform: translate(0px, -45.8859px);"
             data-parallax-speed="0.3"></div>
      </div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js" data-gdlr-animation-duration="600ms"
           data-gdlr-animation-offset="0.8" style="">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div class="gdlr-core-pbf-element">
            <div
              class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-bottom gdlr-core-item-pdlr">
              <div class="gdlr-core-title-item-title-wrap">
                <h3 class="gdlr-core-title-item-title gdlr-core-skin-title"
                    style="font-size: 75px; font-weight: 600; letter-spacing: 0px; text-transform: none; color: #ffffff;">
                  联系我们<span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                </h3>
              </div>
              <span class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption"
                    style="font-size: 25px; font-style: normal; color: #ffffff; margin-top: 15px;">Contact Us</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="gdlr-core-pbf-wrapper" style="padding: 30px 0px 20px 0px;" data-skin="Contact link">
      <div class="gdlr-core-pbf-background-wrap" style="background-color: #f3f3f3;">
        <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
             style="opacity: 0.14; background-image: url(static/upload/QAdTsSj8TOOWzlyLn3Rg_14248396556_aefcd9a926_o.jpg); background-size: cover; background-position: center center; height: 603.175px; transform: translate(0px, -172.091px);"
             data-parallax-speed="0.2"></div>
      </div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div class="gdlr-core-pbf-column gdlr-core-column-15 gdlr-core-column-first" id="gdlr-core-column-2464">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="padding: 50px 20px 0px 20px;">
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js" data-gdlr-animation-duration="600ms"
                   data-gdlr-animation-offset="0.8" style="">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-icon-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align"
                       style="padding-bottom: 40px;">
                    <div class="gdlr-core-icon-item-wrap gdlr-core-skin-e-background gdlr-core-icon-item-type-round"
                         style="background-color: #d34747; border-radius: 40px; -moz-border-radius: 40px; -webkit-border-radius: 40px; padding: 20px 20px 20px 20px;">
                      <i class="gdlr-core-icon-item-icon fa fa-phone gdlr-core-skin-e-content"
                         style="color: #ffffff; font-size: 40px; min-width: 40px; min-height: 40px;"></i>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                    style="padding-bottom: 25px;">
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title"
                          style="font-size: 26px; letter-spacing: 0px; text-transform: none;">
                        联系电话<span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align">
                    <div class="gdlr-core-divider-container" style="max-width: 30px;">
                      <div class="gdlr-core-divider-line gdlr-core-skin-divider"
                           style="border-color: #e5b3b3; border-width: 3px;"></div>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align"
                       style="padding-bottom: 0px;">
                    <div class="gdlr-core-text-box-item-content" style="text-transform: none; color: #ffffff;"><p></p>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align">
                    <div class="gdlr-core-text-box-item-content" style="font-weight: 700; text-transform: none;">
                      <p><a style="text-decoration: underline;" href="#">上海：+86-021-60908368</a></p>
                      <p><a style="text-decoration: underline;" href="#">香港：+852 2887-3889</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="gdlr-core-pbf-column gdlr-core-column-15" id="gdlr-core-column-95780">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="padding: 50px 20px 0px 20px;">
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js" data-gdlr-animation-duration="600ms"
                   data-gdlr-animation-offset="0.8" style="">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-icon-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align"
                       style="padding-bottom: 40px;">
                    <div class="gdlr-core-icon-item-wrap gdlr-core-skin-e-background gdlr-core-icon-item-type-round"
                         style="background-color: #d34747; border-radius: 40px; -moz-border-radius: 40px; -webkit-border-radius: 40px; padding: 24px 24px 24px 24px;">
                      <i class="gdlr-core-icon-item-icon fa fa-envelope-o gdlr-core-skin-e-content"
                         style="color: #ffffff; font-size: 31px; min-width: 31px; min-height: 31px;"></i>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                    style="padding-bottom: 25px;">
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title"
                          style="font-size: 26px; letter-spacing: 0px; text-transform: none;">
                        Email<span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align">
                    <div class="gdlr-core-divider-container" style="max-width: 30px;">
                      <div class="gdlr-core-divider-line gdlr-core-skin-divider"
                           style="border-color: #e5b3b3; border-width: 3px;"></div>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align"
                       style="padding-bottom: 0px;">
                    <div class="gdlr-core-text-box-item-content" style="text-transform: none; color: #ffffff;"><p></p>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align">
                    <div class="gdlr-core-text-box-item-content" style="font-weight: 700; text-transform: none;">
                      <p>
                        <a href="mailto:info@huidetrust.com" class="__cf_email__">info@huidetrust.com</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="gdlr-core-pbf-column gdlr-core-column-15" id="gdlr-core-column-6412">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="padding: 50px 20px 0px 20px;">
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js" data-gdlr-animation-duration="600ms"
                   data-gdlr-animation-offset="0.8" style="">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-icon-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align"
                       style="padding-bottom: 40px;">
                    <div class="gdlr-core-icon-item-wrap gdlr-core-skin-e-background gdlr-core-icon-item-type-round"
                         style="background-color: #d34747; border-radius: 40px; -moz-border-radius: 40px; -webkit-border-radius: 40px; padding: 24px 24px 24px 24px;">
                      <i class="gdlr-core-icon-item-icon fa fa-location-arrow gdlr-core-skin-e-content"
                         style="color: #ffffff; font-size: 31px; min-width: 31px; min-height: 31px;"></i>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                    style="padding-bottom: 25px;">
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title"
                          style="font-size: 26px; letter-spacing: 0px; text-transform: none;">
                        上海总部<span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align">
                    <div class="gdlr-core-divider-container" style="max-width: 30px;">
                      <div class="gdlr-core-divider-line gdlr-core-skin-divider"
                           style="border-color: #e5b3b3; border-width: 3px;"></div>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align"
                       style="padding-bottom: 0px;">
                    <div class="gdlr-core-text-box-item-content" style="text-transform: none; color: #ffffff;">
                      <p>
                        <a>
                          上海市闵行区虹桥镇<br>
                          古北路1699号1706室
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                </div>
              </div>
            </div>
          </div>

          <div class="gdlr-core-pbf-column gdlr-core-column-15" id="gdlr-core-column-6413">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="padding: 50px 20px 0px 20px;">
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js" data-gdlr-animation-duration="600ms"
                   data-gdlr-animation-offset="0.8" style="">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-icon-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align"
                       style="padding-bottom: 40px;">
                    <div class="gdlr-core-icon-item-wrap gdlr-core-skin-e-background gdlr-core-icon-item-type-round"
                         style="background-color: #d34747; border-radius: 40px; -moz-border-radius: 40px; -webkit-border-radius: 40px; padding: 24px 24px 24px 24px;">
                      <i class="gdlr-core-icon-item-icon fa fa-location-arrow gdlr-core-skin-e-content"
                         style="color: #ffffff; font-size: 31px; min-width: 31px; min-height: 31px;"></i>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                    style="padding-bottom: 25px;">
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title"
                          style="font-size: 26px; letter-spacing: 0px; text-transform: none;">
                        香港总部<span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align">
                    <div class="gdlr-core-divider-container" style="max-width: 30px;">
                      <div class="gdlr-core-divider-line gdlr-core-skin-divider"
                           style="border-color: #e5b3b3; border-width: 3px;"></div>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align"
                       style="padding-bottom: 0px;">
                    <div class="gdlr-core-text-box-item-content" style="text-transform: none; color: #ffffff;">
                      <p>
                        <a>
                          香港九龙尖沙咀广东道33号<br>
                          中港城1座1806室<br>
                          香港九龙尖沙咀广东道30号<br>
                          新港中心2座1779室

                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="gdlr-core-pbf-wrapper" style="padding: 170px 0px 90px 0px;">
      <div class="gdlr-core-pbf-background-wrap" style="background-color: #f7f7f7;"></div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div class="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js">
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js" style="max-width: 960px;">
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-stunning-text-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-right-align gdlr-core-stunning-text-caption-below-title">
                    <h3 class="gdlr-core-stunning-text-item-title">上海总部</h3>
                    <div class="gdlr-core-stunning-text-item-caption gdlr-core-info-font gdlr-core-skin-caption"
                         style="font-size: 18px;">上海市闵行区古北路1699号1706室
                    </div>
                    <div class="gdlr-core-stunning-text-item-content" style="font-size: 19px;">
                      <center>
                        <div id='mapContainer'></div>
                      </center>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-stunning-text-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-right-align gdlr-core-stunning-text-caption-below-title">
                    <h3 class="gdlr-core-stunning-text-item-title">香港总部</h3>
                    <div class="gdlr-core-stunning-text-item-caption gdlr-core-info-font gdlr-core-skin-caption"
                         style="font-size: 18px;">香港九龙尖沙咀广东道33号中港城1座1806室
                    </div>
                    <div class="gdlr-core-stunning-text-item-content" style="font-size: 19px;">
                      <center>
                        <div id='mapContainer2'></div>
                      </center>
                    </div>
                    <div class="gdlr-core-stunning-text-item-caption gdlr-core-info-font gdlr-core-skin-caption"
                         style="font-size: 18px;">香港九龙尖沙咀广东道30号新港中心2座1779室
                    </div>
                    <div class="gdlr-core-stunning-text-item-content" style="font-size: 19px;">
                      <center>
                        <div id='mapContainer3'></div>
                      </center>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {}
  },
  methods: {
    init () {

      var container = document.getElementById("mapContainer")
      var center = new TMap.LatLng(31.188018,121.40268)
      //初始化地图
      var map = new TMap.Map(container, {
        rotation: 20,//设置地图旋转角度
        pitch:30, //设置俯仰角度（0~45）
        zoom:16,//设置地图缩放级别
        center: center//设置地图中心点坐标
      })

      var marker = new TMap.MultiMarker({
        id: "marker-layer", //图层id
        map: map,
        geometries: [{ //点标注数据数组
          "id": "demo",
          "styleId": "marker",
          "position": new TMap.LatLng(31.188018,121.40268),
          "properties": {
            "title": "marker"
          }
        }]
      })

      var container2 = document.getElementById("mapContainer2");
      var center2 = new TMap.LatLng(22.297631,114.17307);
      //初始化地图
      var map2 = new TMap.Map(container2, {
        rotation: 20,//设置地图旋转角度
        pitch:30, //设置俯仰角度（0~45）
        zoom:16,//设置地图缩放级别
        center: center2//设置地图中心点坐标
      })

      var marker2 = new TMap.MultiMarker({
        id: "marker-layer2", //图层id
        map: map2,
        geometries: [{ //点标注数据数组
          "id": "demo2",
          "styleId": "marker2",
          "position": new TMap.LatLng(22.297631,114.17307),
          "properties": {
            "title": "marker"
          }
        }]
      })

      var container3 = document.getElementById("mapContainer3");
      var center3 = new TMap.LatLng(22.2948,114.17401);
      //初始化地图
      var map3 = new TMap.Map(container3, {
        rotation: 20,//设置地图旋转角度
        pitch:30, //设置俯仰角度（0~45）
        zoom:16,//设置地图缩放级别
        center: center3//设置地图中心点坐标
      })

      var marker3 = new TMap.MultiMarker({
        id: "marker-layer3", //图层id
        map: map3,
        geometries: [{ //点标注数据数组
          "id": "demo3",
          "styleId": "marker3",
          "position": new TMap.LatLng(22.2948,114.17401),
          "properties": {
            "title": "marker"
          }
        }]
      })
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Contact.vue